import {
  getMemberInfo
} from '@/api/member' // 导入资金信息相关接口

const student = {
  state: {
    addStudentDialog: {
      title: '新增学员信息',
      type: 'add'
    },
    studentSearch: {
      stdName: '',
      stdStatus: ''
    },
    memberList: [],
    studentSearchBtnDisabled: true
  },
  getters: {
    addStudentDialog: state => state.addStudentDialog,
    studentSearch: state => state.studentSearch,
    studentSearchBtnDisabled: state => state.studentSearchBtnDisabled,
    memberList: state => state.memberList
  },
  mutations: {
    SET_STUDENT_DIALOG_TITLE: (state, type) => {
      // console.log("type:"+type);
      if (type === 'add') {
        state.addStudentDialog.title = '新增学员信息'
        state.addStudentDialog.type = 'add'
      } else {
        // console.log("edit");
        state.addStudentDialog.title = '编辑学员信息'
        state.addStudentDialog.type = 'edit'
      }
    },
    SET_STUDENT_SEARCH: (state, payload) => {
      // console.log(payload);
      state.studentSearch = payload;
    },
    SET_STUDENT_SEARCHBTN_DISABLED: (state, payload) => {
      state.studentSearchBtnDisabled = payload;
    },
    SET_MEMBER_LIST: (state, payload) => {
      state.memberList = payload;
    }
  },
  actions: {
    // 获取会员列表
    //  GetMemberList({commit},reqData) {
    //     return new Promise(resolve => {
    //         getMemberInfo(reqData).then(response => {
    //             const data = response.data
    //             resolve(data)
    //         })
    //     })
    // } 
  }
}

export default student